<template>
  <div>
    <b-modal
      id="modal-center"
      ok-only
      centered
      title="Payment Widget Preview"
      :static="true"
    >
      <div style="display: inline;">
        <code>
          &lt;div id="cdsgpw" cfg-id="</code>{{ pwConfigNumber }}<code>"/&gt;
        </code>
      </div>
    </b-modal>
  </div>
</template>

<script>


export default {
  name: 'PaymentwidgetPreview',
  components: {
  },
  props: {
    pwConfigNumber: { type: String, required: true }
  },
  data: function () {
    return {
      isModalStatic: true
    }
  },
  computed: {
    pwLoading() {
      return this.$store.state.pwpreview.pwLoading
    }
  },
  beforeCreate: function () {
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
    showModal() {
      this.$refs.myModalRef.show()
    }
  }
}
</script>
